<template>
  <div id="social" :class="{'show' : show || $route.name === 'Lab'}">
    <ul>
      <li>
        <a href="https://github.com/baptisteVillain/">
          <svg aria-labelledby="simpleicons-github-icon" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title id="simpleicons-github-icon">GitHub icon</title><path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"/></svg>
        </a>
      </li>
      <li>
        <a href="https://www.linkedin.com/in/baptiste-villain-91856412a/">
          <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="linkedin-in" class="svg-inline--fa fa-linkedin-in fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"></path></svg>
        </a>
      </li>
    </ul>
    <h3>
      <a href="mailto:baptiste.villain@hetic.net">Feel free to contact me</a>
    </h3>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'

export default {
  name: 'Socials',
  computed: {
    ...mapGetters({
      show: 'show'
    })
  },
}
</script>

<style lang="scss">
  #social{
    position: fixed;
    z-index: 150;
    left: var(--body-padding);
    bottom: calc(var(--body-padding) - 3px);
    &.show{
      a{
        color: var(--white);
      }
      svg path{
        fill: var(--white);
      }
    }
    h3{
      margin: 16px 0 0 0;
      padding: 0;
      a{
        font-family: var(--conduitITC);
        font-size: 1.4rem;
        font-weight: 400;
        color: var(--black);
        text-decoration: none;
        position: relative;
        padding: 4px 0;
        &::after{
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 2px;
          background: var(--primary);
          transform-origin: 0% 100%;
          transform: scaleX(.2);
          transition: transform .25s cubic-bezier(0.48, 0.04, 0.52, 0.96);
        }
        &:hover{
          &::after{
            transform: scaleX(1);
          }
        }
      }
    }
    ul{
      padding: 0;
      margin: 0;
      list-style: none;
      display: flex;
      flex-direction: row;
      li{
        margin-right: 1.6rem;
        a{
          display: flex;
          justify-content: center;
          align-items: center;
          width: 1.6rem;
          height: 1.6rem;
          &:hover {
            svg path {
              fill: var(--primary);
            }
          }
          svg{
            height: 1.6rem;
            path{
              fill: var(--black);
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Social.vue